module.exports = __webpack_public_path__ + "img/galery9.c9cc852a.jpg";